import { SET_LANGUAGE } from '../constants';
// ##### Komarov 2025-09-03
import config from '../config';

// ##### 23-03-28 Komarov: Функция для добавления в Redux store поля language
export default (state = config.defaultLang, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      return action.payload;
    default:
      return state;
  }
};
